import React from 'react';

export const ExternalHashList = ({list}) => {


  return(
    <div className="externalHastListTable">
      <table className="table table-striped table-hover">
        <thead>
        <tr>
          <th>Campaign Name</th>
          <th>Campaign URL Identifier</th>
        </tr>
        </thead>
        <tbody>
        {list.map((ext, index) =>
          <tr key={index}>
            <td>{ext.name}</td>
            <td>{ext.externalHashId}</td>
          </tr>
        )}
        </tbody>
      </table>

    </div>
  )

}



